var _rect, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamMenuMclaren(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 600,
    viewBox: "0 0 440 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_626)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 600,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3_626)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_626",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 2400,
    height: 800
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2400 0H0V800H2400V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-23.587 687.54L777.16 58.466H1268.83L300.331 819.329L-23.587 818.53V687.54Z",
    fill: "url(#paint0_linear_3_626)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.44 -12.141L324.122 625.24H777.567L1589.9 -12.939L1135.44 -12.141Z",
    fill: "url(#paint1_linear_3_626)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.5869 513.738L368.856 205.431H748.286L-27.8569 815.176L-23.5869 513.738Z",
    fill: "url(#paint2_linear_3_626)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.232 817.891L709.245 434.505H1158.22L667.052 820.367L221.232 817.891Z",
    fill: "url(#paint3_linear_3_626)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.019 -12.939L160.942 435.703H592.122L1165.49 -14.736L732.019 -12.939Z",
    fill: "url(#paint4_linear_3_626)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.143 -12.939L66.593 228.674H637.67L952.26 -18.47L374.143 -12.939Z",
    fill: "url(#paint5_linear_3_626)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.8 -10.224L130.492 298.762H-178.938L219.529 -14.277L523.8 -10.224Z",
    fill: "url(#paint6_linear_3_626)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-178.938 449.84L194.608 156.38H622.623L-171.522 780.267L-178.938 449.84Z",
    fill: "url(#paint7_linear_3_626)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.674 -18.47L-78.895 412.49H280.976L828.052 -17.297L469.674 -18.47Z",
    fill: "url(#paint8_linear_3_626)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.8569 815.176L298.789 558.56H735.272L405.923 817.299L-27.8569 815.176Z",
    fill: "url(#paint9_linear_3_626)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.587 369.04H422.944L-34.447 728.37L-23.587 369.04Z",
    fill: "url(#paint10_linear_3_626)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.227 -29.228L-93.73 423.248V-26.744L482.227 -29.228Z",
    fill: "url(#paint11_linear_3_626)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.944 -121.136L-153.012 331.34V-118.652L422.944 -121.136Z",
    fill: "url(#paint12_linear_3_626)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M2400 0H0V800H2400V0Z",
    fill: "#F57F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M233.598 271.944C233.598 273.478 232.922 274.589 230.828 274.589H217.461C215.738 274.589 214.755 274.091 214.755 272.494C214.755 270.897 215.431 270.104 217.461 270.104H233.598V271.944ZM292.542 265.556V263.831C292.542 262.233 293.219 261.186 295.376 261.186H308.743C310.581 261.186 311.501 261.735 311.501 263.46C311.501 264.929 310.773 265.607 308.871 265.607L292.542 265.556ZM327.638 253.711V281.949H341.158V261.441H352.188C355.941 261.441 357.844 262.617 357.844 266.233V282.013H371.338V265.121C371.338 257.199 366.972 253.762 354.652 253.762L327.638 253.711ZM294.444 253.711C283.58 253.711 279.226 257.327 279.226 265.492V271.088C279.226 278.142 283.58 281.949 293.397 281.949H321.931V274.577H296.04C293.487 274.577 292.606 273.836 292.606 271.932V270.769H313.033C320.08 270.769 324.063 268.558 324.063 263.281V262.003C324.063 257.212 321.676 253.774 309.713 253.774L294.444 253.711ZM251.038 281.949H264.532V263.46C264.532 262.182 265.03 261.428 266.69 261.428H277.12V253.762H262.119C254.076 253.762 251.012 256.764 251.012 261.799L251.038 281.949ZM204.912 253.711V261.147H230.254C232.807 261.147 233.637 262.016 233.637 263.856V264.942H213.287C204.759 264.942 202.192 268.456 202.192 272.928V274.027C202.192 280.237 207.159 281.949 216.912 281.949H231.888C242.497 281.949 247.093 279.56 247.093 271.203V264.687C247.093 257.621 242.739 253.762 232.871 253.762L204.912 253.711ZM124.15 269.478C124.15 278.423 128.682 282.001 140.402 282.001H166.114V274.334H142.368C139.546 274.334 137.644 273.056 137.644 268.993V266.591C137.644 262.962 139.419 261.479 142.304 261.479H166.114V253.813H140.032C128.542 253.813 124.15 258.656 124.15 266.399V269.478ZM170.11 249.277V282.001H199.473V274.334H183.642V249.277H170.11ZM85.8498 267.574V249.277H78.1898C73.4661 249.277 70.7724 251.168 67.9765 253.391L32 282.001H48.252L72.1895 262.604V282.001H83.4114L106.596 262.476V282.001H120.345V249.277H112.851C108.804 249.277 105.983 250.938 103.161 253.263L85.8498 267.574Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M403.791 225.51C396.259 225.51 385.649 227.759 374.147 231.976C363.862 235.718 354.016 240.573 344.783 246.453C353.639 243.195 362.977 241.446 372.41 241.278C385.611 241.278 395.007 246.389 381.13 264.061C421.983 237.227 420.924 225.574 403.791 225.574",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.221 310.278H115.596V312.744H109.877V315.657H114.983V318.136H109.877V323.247H107.221V310.278Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.746 316.884V316.667C125.746 312.757 128.197 310.022 131.644 310.022C135.091 310.022 137.516 312.731 137.516 316.628V316.846C137.516 320.679 135.053 323.49 131.618 323.49C128.184 323.49 125.746 320.768 125.746 316.884ZM134.682 316.884V316.667C134.682 314.111 133.406 312.488 131.58 312.488C129.754 312.488 128.516 314.111 128.516 316.667V316.794C128.516 319.35 129.793 320.986 131.644 320.986C133.495 320.986 134.721 319.376 134.721 316.82L134.682 316.884Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M148.713 310.278H153.602C154.243 310.247 154.883 310.344 155.486 310.564C156.089 310.783 156.642 311.12 157.113 311.556C157.491 311.958 157.783 312.432 157.971 312.951C158.16 313.469 158.242 314.02 158.211 314.571C158.253 315.381 158.043 316.184 157.611 316.87C157.179 317.556 156.546 318.092 155.798 318.404L158.569 323.234H155.492L153.092 318.954H151.407V323.234H148.7L148.713 310.278ZM153.398 316.667C153.671 316.703 153.948 316.678 154.21 316.595C154.472 316.512 154.713 316.372 154.915 316.186C155.117 315.999 155.276 315.77 155.38 315.516C155.484 315.261 155.531 314.986 155.517 314.712C155.517 313.434 154.713 312.757 153.347 312.757H151.419V316.667H153.398Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M169.459 310.278H172.28L175.178 315.555L178.051 310.278H180.885V323.26H178.242V314.954L175.178 320.321L172.127 314.993V323.26H169.574L169.459 310.278Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M192.515 318.2V310.278H195.222V318.251C195.222 320.091 196.09 320.998 197.481 320.998C198.873 320.998 199.754 320.104 199.754 318.302V310.278H202.422V318.174C202.422 321.765 200.456 323.503 197.443 323.503C194.43 323.503 192.515 321.778 192.515 318.2Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M214.053 310.278H216.747V320.819H222.006V323.298H214.053V310.278Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M236.905 310.176H239.458L244.131 323.26H241.373L240.378 320.5H235.909L234.99 323.26H232.296L236.905 310.176ZM239.561 318.059L238.143 313.817L236.714 318.059H239.561Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M269.983 312.923L268.005 313.459L267.571 311.121L270.737 310.15H272.601V323.26H269.945L269.983 312.923Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M300.623 312.744H297.355V310.278H306.573V312.833H303.292V323.349H300.623V312.744Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M317.258 310.278H325.633V312.706H319.952V315.517H324.969V317.944H319.952V320.845H325.723V323.286H317.271L317.258 310.278Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M340.749 310.176H343.302L347.962 323.26H345.179L344.234 320.5H339.753L338.809 323.324H336.102L340.749 310.176ZM343.405 318.059L342 313.817L340.57 318.059H343.405Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M358.584 310.278H361.38L364.278 315.555L367.176 310.278H370.023V323.26H367.38V314.954L364.316 320.321L361.265 314.993V323.26H358.635L358.584 310.278Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_626",
    x1: 900.323,
    y1: 136.714,
    x2: 220.425,
    y2: 715.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_626",
    x1: 1272.85,
    y1: -137.826,
    x2: 761.393,
    y2: 581.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_626",
    x1: 64.8379,
    y1: 608.483,
    x2: 513.999,
    y2: 232.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_626",
    x1: 360.898,
    y1: 964.812,
    x2: 866.563,
    y2: 444.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3_626",
    x1: 276.23,
    y1: 500.058,
    x2: 646.348,
    y2: 223.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3_626",
    x1: 200.656,
    y1: 336.248,
    x2: 496.014,
    y2: 115.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3_626",
    x1: -97.0263,
    y1: 345.774,
    x2: 160.629,
    y2: 153.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3_626",
    x1: -214.997,
    y1: 637.815,
    x2: 132.876,
    y2: 377.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3_626",
    x1: 20.1718,
    y1: 462.726,
    x2: 359.101,
    y2: 209.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3_626",
    x1: 560.964,
    y1: 452.869,
    x2: 185.719,
    y2: 876.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3_626",
    x1: -34.4468,
    y1: 548.705,
    x2: 422.944,
    y2: 548.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3_626",
    x1: -52.7464,
    y1: 236.907,
    x2: 146.834,
    y2: 22.8643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3812,
    stopColor: "#8D1B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3_626",
    x1: -120.145,
    y1: 194.088,
    x2: 66.3138,
    y2: -35.3992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3812,
    stopColor: "#8D1B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 600,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3_626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2400,
    height: 800,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamMenuMclaren);
export default __webpack_public_path__ + "static/media/team_menu_mclaren.9358b233b10612f6451d2a6faa0d4954.svg";
export { ForwardRef as ReactComponent };